import React, { useEffect, useMemo } from "react";
import { Button, Icon, Progress, Table, Upload } from "antd";
import { Redirect } from "react-router-dom";

import Base from "../../../components/Base";
import { TableColumns } from "./table-columns";
import { FetchStatus, useFetchFiles } from "./use-fetch-files";
import { format } from "../../../utils/DateFormater";
import { UploadStatus, useFileUpload } from "./use-file-upload";
import "./styles.css";
import { isSuperUser } from "../../../utils/is-superuser";

function formatFileName(path) {
  if (String(path).includes("/media/")) {
    return path.split("/media/")[1];
  }

  return path;
}

function buildResult(file) {
  if (!file.resultado) {
    return {
      added: 0,
      removed: 0,
      data: file
    };
  }

  if (file.resultado.erro) {
    return {
      error: file.resultado.erro
    };
  }

  const {
    parcelas_novas,
    devedores_novos,
    operacoes_novas,
    parcelas_removidas,
    devedores_removidos,
    operacoes_removidas
  } = file.resultado;

  return {
    added: parcelas_novas + devedores_novos + operacoes_novas,
    removed: parcelas_removidas + devedores_removidos + operacoes_removidas,
    data: file
  };
}

export const UploadTXT = () => {
  const { status, data, refresh } = useFetchFiles();
  const { upload, filename, progress, status: uploadStatus } = useFileUpload();

  const tableData = useMemo(
    () =>
      (data || []).map(file => ({
        key: file.id,
        status: [file.processado, file.resultado && file.resultado.erro], // bool
        arquivo: formatFileName(file.file),
        dt_cadastro: file.dt_cadastro ? format(file.dt_cadastro) : "---",
        dt_arquivo: format(file.dt_arquivo),
        dt_processamento: file.dt_processamento
          ? format(file.dt_processamento)
          : "---",
        resultado: buildResult(file),
        acoes: [file.processado, file.id]
      })),
    [data]
  );

  const isUploading =
    uploadStatus === UploadStatus.UPLOADING ||
    uploadStatus === UploadStatus.ERROR ||
    uploadStatus === UploadStatus.SUCCESS;
  const isFailed = uploadStatus === UploadStatus.ERROR;
  const isSuccess = uploadStatus === UploadStatus.SUCCESS;

  useEffect(
    function onUploadComplete() {
      if (uploadStatus === UploadStatus.SUCCESS) {
        refresh();
      }
    },
    [uploadStatus]
  );

  if (!isSuperUser()) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <Base
      title="Upload de TXT"
      subTitle="Processar novos contratos/parcelas via txt"
      extra={[
        <Upload
          name="file"
          accept=".txt"
          customRequest={upload}
          showUploadList={false}
        >
          <Button
            type="primary"
            disabled={isUploading && progress !== 100 && !isFailed}
          >
            <Icon type="upload" />
            Fazer upload (.txt)
          </Button>
        </Upload>
      ]}
    >
      <div className="upload-txt__container">
        <div className="upload-txt__title">
          <Icon type="file-text" />
          <span>Lista de processamentos</span>
        </div>

        {isUploading && (
          <div className="upload-txt__progress">
            <span>
              {!isFailed && !isSuccess && <Icon type="loading" />}
              &nbsp;
              <span style={{ opacity: 0.6 }}>{filename}</span>
            </span>
            <Progress
              percent={progress}
              status={isFailed ? "exception" : isSuccess ? "success" : "active"}
            />
          </div>
        )}

        <Table
          pagination={false}
          dataSource={tableData}
          columns={TableColumns}
          loading={status === FetchStatus.LOADING}
          scroll={{ x: true }}
          locale={{
            emptyText: "Vazio"
          }}
        />
      </div>
    </Base>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Contratos/UploadTXT/index.jsx